import React, { PureComponent } from 'react';
import { Tabs, Tab, Row, Col } from 'react-bootstrap';
import axios from 'axios';
import appConstant from '../../../../constants/app';
var _ = require('lodash')

class SectionsPanel extends PureComponent {
  state = {
    key: 1,
  }

  onClickTrendingLink = (e, linkId) => {
    axios({
      method: 'post',
      url: `${appConstant.API_URL}/link/click`, 
      data: {
        id: linkId,
      },
    })
    .then(res => {
    }).catch(err => {
      console.log(err);
    });
  }

  render() {
    return (
      <Row className="sections-tabs-wrapper">
        <Col className="sections-tabs-wrapper-col" sm={12}>
          <Tabs className="landing-tabs-sections" animation={false}>
            {this.props.sections.map((section, index) => {
              let groupRows = _.chunk(section.groups, 3);

              return (
                <Tab className="tab-section" eventKey={`${index + 1}`} title={section.label} key={`l-tab-${index}`}>
                  {groupRows && groupRows.map((groupCol, index) => (
                    <Row className="tab-section-row" key={`tabs-${index}`}>
                      {groupCol && groupCol.map((group, index) => (
                        <Col className="tab-section-col" xs={4} key={`grouptabs-${index}`}>
                          <div className="group-section">
                            {group.label}
                            {group.links && group.links.map((link, index) => (
                              <div className="group-link-section" key={`tab${link.id}`}>
                                <a
                                  onClick={(e) => {
                                    this.onClickTrendingLink(e, link.id)
                                  }}
                                  href={link.url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {link.label}
                                </a>
                              </div>
                            ))}
                          </div>
                        </Col>
                      ))}
                    </Row>
                  ))}
                </Tab>
              );
            })}
          </Tabs>
        </Col>
      </Row>
    )
  }
}

export default SectionsPanel;



// WEBPACK FOOTER //
// ./src/app/screens/landing/sections/sectionsTabs.js